import { ILotTypeFormValues } from './lotTypeFormValues';
import { z } from 'zod';
import { baseModelSchema } from '../../baseModel';

/**
 * Zod schema for validating lot type data.
 * Extends the base model schema with lot type-specific fields.
 * Represents a classification type for lots in the system.
 *
 * @property {string} name - Name of the lot type (max 255 characters)
 * @property {boolean} isSwappable - Whether lots of this type can be swapped
 */
export const lotTypeSchema = baseModelSchema.extend({
    name: z.string().nonempty('Name is required').max(255, 'Name can only be up to 255 characters long.').default(''),
    isSwappable: z.boolean().default(false),
});

/**
 * TypeScript interface representing a LotType object.
 * Generated from the Zod schema for type safety.
 */
export type ILotType = z.infer<typeof lotTypeSchema>;

/**
 * Creates a validated LotType object from form values.
 *
 * @param {ILotTypeFormValues} formValues - The form data to convert
 * @returns {ILotType} A validated lot type object
 * @throws {ZodError} If validation fails
 */
export function LotType(formValues : ILotTypeFormValues) : ILotType {
    return lotTypeSchema.parse({
        ...formValues,
    });
};
